import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

export interface FeatureCycle {
    imgUrl: string;
    title: string;
}
@Component
export default class EpicCycleCompanyList extends Vue {
    @Prop({ default: function () {
        return [{
            imgUrl: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/company-logo-1.png',
            title: 'Rifo Realty'
        }, {
            imgUrl: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/company-logo-2.png',
            title: 'Eastide Holding Group'
        },
        {
            imgUrl: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/company-logo-3.png',
            title: 'Queen FINANCE Group'
        }, {
            imgUrl: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/company-logo-4.png',
            title: 'MASTER’S CHOICE REALTY'
        },
        {
            imgUrl: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/company-logo-5.png',
            title: 'rOYAL PACIFIC REALTY'
        }, {
            imgUrl: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/company-logo-6.png',
            title: 'Homeart REALTY'
        },
        {
            imgUrl: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/company-logo-7.png',
            title: 'Royal ELITE REALTY'
        }, {
            imgUrl: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/company-logo-8.png',
            title: 'Kestrel CAPITAL'
        },
        {
            imgUrl: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/company-logo-9.png',
            title: 'Eastide REALTY'
        },
        // {
        //     imgUrl: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/company-logo-10.png',
        //     title: 'AIM HOME REALTY'
        // },
        {
            imgUrl: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/company-logo-11.png',
            title: 'BAIM CAPITAL'
        }, {
            imgUrl: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/company-logo-12.png',
            title: 'RED FUND CAPITAL'
        },
        {
            imgUrl: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/company-logo-13.png',
            title: 'REALJAJA GROUP'
        }, {
            imgUrl: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/company-logo-14.png',
            title: 'ARTSY HOME STAGING'
        }];
        }
    })
    public features!: FeatureCycle[];
}
